import { Inject, Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { firstValueFrom } from "rxjs";

import { Location } from "@angular/common";
import { CryptographyService } from "./cryptography.service";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";

@Injectable({
  providedIn: "root",
})
export class CustomEventNRService {
  constructor(
    private http: HttpClient,
    private location: Location,
    private cryptographyService: CryptographyService,
    @Inject(LOCAL_STORAGE)
    public storage: WebStorageService,
  ) {}
  // Forwards to New Relic through our own backend (AnalyticsController),
  // instead of posting to New Relic directly from the browser with a
  // hardcoded Api-Key - keeps the key server-side only. Uses HttpClient
  // (not a raw fetch) so the auth interceptor attaches the bearer token the
  // [Authorize]-protected endpoint requires.
  private url = "/api/Analytics/RecordSearchEvent";

  async sendSearchEvent(Eventname, searchKey, searchResultsCount, pageUrl) {
    await firstValueFrom(
      this.http.post(this.url, {
        eventType: Eventname,
        searchKey,
        searchResultsCount,
        pageUrl,
        session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
      })
    );
  }
   async sendFilterEvent(eventType, activeFilters, resultsCount) {
    await firstValueFrom(
      this.http.post(this.url, [
        {
          eventType: eventType,
          activeFilters: activeFilters,
          resultsCount: resultsCount,
          session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
        },
      ])
    );
  }
}

 
